import * as React from "react";
import { Link, useParams } from "react-router-dom";

import {
  RiArrowRightLine,
  RiPhoneLine,
  RiMapPin2Line,
  RiMailLine,
} from "react-icons/ri";

import Button from "../../../Components/Button";
import Paper from "../../../Components/Paper";

import axiosInstance from "../../../Api/Axios";
import { useLoader } from "../../../Context/LoaderContext";

import "./ConfirmRequest.scss";

const ConfirmRequest = () => {
  const [referenceSimulation, setReferenceSimulation] = React.useState([]);

  const { setIsLoading } = useLoader();
  const { id } = useParams();
  React.useEffect(() => {
    setIsLoading(true);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation/${id}`)
      .then((response) => {
        setIsLoading(false);
        setReferenceSimulation(response?.data?.data?.reference || {});
      })

      .catch((error) => {
        setIsLoading(false);
      });
  }, [id, setIsLoading]);

  return (
    <>
      <Paper>
        <div className="wrap-confirm-request">
          <div className="title-confirm-request">
            Confirmation de Soumission de la Demande
          </div>
          <div className="sub-title-confirm-request">
            Notre équipe examinera les informations et les documents fournis.
            Vous serez contacté par notre service client sous peu pour la suite
            du traitement de votre demande.
          </div>
          <div className="box-folder-number">
            <div className="title-folder-number">Numéro de Dossier</div>
            <div className="folder-number">{referenceSimulation}</div>
          </div>
          <div className="box-confiance">
            <div className="title-confiance">Merci de votre confiance</div>
            <div className="content-confiance">
              Si vous avez des questions ou des préoccupations,
              <br />
              n'hésitez pas à contacter notre service client
            </div>
          </div>
          <div className="wrap-adress-demande">
            
            <div className="box-adress-demande">
              <div className="icon-adress-demande">
                <RiPhoneLine />
              </div>
              <div className="content-adress-demande">
                <div className="title-adress-demande">Appelez nous</div>
                <div className="caption-adress-demande">
                  (+216) 70 136 436 <br />
                  (+216) 39 140 836
                </div>
              </div>
            </div>
            <div className="box-adress-demande">
              <div className="icon-adress-demande">
                <RiMailLine />
              </div>
              <div className="content-adress-demande">
                <div className="title-adress-demande">Adresse email </div>
                <div className="caption-adress-demande">
                  <a href="mailto:service.client@attijarileasing.com.tn">
                    service.client@attijarileasing.com.tn
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="wrap-link-request">
            <Button>
              <Link to="/">
                Retour vers la page d'accueil
                <RiArrowRightLine />
              </Link>
            </Button>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default ConfirmRequest;
